import React from 'react';
import { FileText, ChevronDown, ChevronUp } from 'lucide-react';
import moment from 'moment';

class InvoiceTableView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedGroups: new Set(),
    };
  }

  toggleGroup = (key) => {
    this.setState(prevState => {
      const newExpanded = new Set(prevState.expandedGroups);
      if (newExpanded.has(key)) {
        newExpanded.delete(key);
      } else {
        newExpanded.add(key);
      }
      return { expandedGroups: newExpanded };
    });
  };

  bindInvoices = (invoiceList) => {
    let invList = Object.keys(invoiceList);
    
    return invList.map((item, index) => (
      <tr key={index} className="hover:bg-gray-50 transition-colors duration-150">
        <td className="w-12 py-2.5 pl-6">
          <FileText className="h-4 w-4 text-slate-400" />
        </td>
        <td className="py-2.5 pr-6">
          {invoiceList[item] && invoiceList[item].length > 0 ? (
            <button
              type="button"
              onClick={() => {
                if (invoiceList[item].length > 0) {
                  window.open(invoiceList[item][0].attachmentURL);
                }
              }}
              className="text-blue-600 hover:text-blue-700 font-medium transition-colors duration-150"
            >
              {item}
            </button>
          ) : (
            <span className="text-slate-600">{item}</span>
          )}
        </td>
        <td className="py-2.5 px-6"></td>
        <td className="py-2.5 px-6"></td>
      </tr>
    ));
  };

  bindDateGroups = () => {
    let noInvoiceDatesCount = 0;
    let dateGroups = this.props.invoiceList.map((item, key) => {
      if (Object.keys(item.attachments).length > 0) {
        const eventKey = (key + 1).toString();
        const isExpanded = this.state.expandedGroups.has(eventKey);
        
        return (
          <div key={eventKey} className="mb-2 bg-white rounded-lg shadow-sm">
            <button
              type="button"
              onClick={() => this.toggleGroup(eventKey)}
              className="w-full px-6 py-3 flex items-center justify-between text-slate-700 hover:bg-gray-50 rounded-lg transition-colors duration-150"
            >
              <div className="flex items-center space-x-2">
                <span className="text-sm font-medium">
                  {moment(item.createdDate).format('YYYY/MM/DD')}
                </span>
              </div>
              <div className="transform transition-transform duration-200">
                {isExpanded ? (
                  <ChevronUp className="h-5 w-5 text-slate-400" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-slate-400" />
                )}
              </div>
            </button>
            
            <div className={`transform origin-top transition-all duration-200 ease-in-out overflow-hidden ${
              isExpanded ? 'h-auto opacity-100' : 'h-0 opacity-0'
            }`}>
              <div className="border-t border-gray-100">
                <div className="p-0">
                  <table className="w-full">
                    <tbody className="divide-y divide-gray-100">
                      {this.bindInvoices(item.attachments)}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        );
      } else {
        noInvoiceDatesCount++;
        return null;
      }
    });

    if (this.props.invoiceList.length === noInvoiceDatesCount) {
      return (
        <div className="rounded-lg bg-white p-6 text-center text-slate-500 shadow-sm">
          No Invoices data exists for this month
        </div>
      );
    }

    return dateGroups;
  };

  render() {
    return (
      <div className="w-full p-6 bg-gray-50 min-h-screen">
        <div className="mb-6 bg-white rounded-lg shadow-sm">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-100">
                <th className="w-12 py-3 pl-6 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">#</th>
                <th className="py-3 pr-6 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Invoice No</th>
                <th className="py-3 px-6 text-left text-xs font-medium text-slate-500 uppercase tracking-wider"></th>
                <th className="py-3 px-6 text-left text-xs font-medium text-slate-500 uppercase tracking-wider"></th>
              </tr>
            </thead>
          </table>
        </div>
        
        <div>
          {this.bindDateGroups()}
        </div>
      </div>
    );
  }
}

export default InvoiceTableView;